<div fxLayoutAlign="space-around" class="title colors" mat-dialog-title>{{dialogData?.title}}</div>

<div class="msg" mat-dialog-content>
  {{dialogData?.message}}
</div>


<div class="d-flex justify-content-end mt-3">
  <button mat-button color="accent" (click)="matDialogRef.close()">No</button>
  <button mat-button color="primary" (click)="closeWithYes()">Yes</button>
</div>
